import { createPortal } from 'react-dom';

import { DSProgressIndicator } from '@demandstar/components/progress-indicator';
import { useDSSelector } from '../../store/reducers';

const loaderElement = document.getElementById('loaderOverlay') as HTMLElement;

type LoaderProps = {
  loading?: boolean;
};

export function Loader({ loading }: LoaderProps) {
  const isLoading = useDSSelector(state => state.loader?.isLoading);
  const isSuspenseLoading = useDSSelector(state => state.shared?.isSuspenseLoading);
  return createPortal(
    loading || isLoading || isSuspenseLoading ? (
      <div className='overlay'>
        <div className='progressbox'>
          <div className='ml-5'>
            {/* <DSProgressIndicator /> */}
            <svg id="Layer_2" data-name="Layer 2"
              xmlns="http://www.w3.org/2000/svg"
              width="70" height="70"
              viewBox="-4 -4 45 37">

              <g id="Outlined_Type" data-name="Outlined Type">
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="rotate"
                  from="0 18 14.5"
                  to="360 18 14.5"
                  dur="0.7s"
                  repeatCount="indefinite" />

                <g>
                  <g>
                    <g>

                      <path d="M21.43,8.52c0,2.36-.96,4.5-2.52,6.05h0c1.54-1.53,3.66-2.47,6-2.47s4.5.96,6.05,2.52c1.56-1.54,2.52-3.68,2.52-6.05V.05h-8.52c-2.34,0-4.46.95-6,2.47,1.53,1.54,2.47,3.66,2.47,6Z" fill="#ff6e14" />
                      <path d="M24.96,17.09h0c-2.36,0-4.5-.96-6.05-2.52h0c1.53,1.54,2.47,3.66,2.47,6s-.96,4.5-2.52,6.05c1.54,1.56,3.68,2.52,6.05,2.52h8.52v-8.52c0-2.34-.94-4.46-2.47-6-1.54,1.53-3.66,2.47-6,2.47" fill="#6145f7" />
                      <path d="M21.38,20.57c0-2.34-.94-4.46-2.47-6-1.56,1.54-2.52,3.68-2.52,6.05s.94,4.46,2.47,6c1.56-1.54,2.52-3.68,2.52-6.05" fill="#2b3484" />
                      <path d="M18.91,14.57h0c-1.53-1.54-2.47-3.66-2.47-6s.96-4.5,2.52-6.05c-1.54-1.56-3.68-2.52-6.05-2.52H4.39v8.52c0,2.34.95,4.46,2.47,6,1.54-1.53,3.66-2.47,6-2.47s4.5.96,6.05,2.52" fill="#6145f7" />
                      <path d="M18.91,14.58h0c-1.54,1.53-3.66,2.47-6,2.47s-4.5-.96-6.05-2.52c-1.56,1.54-2.52,3.68-2.52,6.05v8.52h8.52c2.34,0,4.46-.95,6-2.47-1.53-1.54-2.47-3.66-2.47-6s.96-4.5,2.52-6.05" fill="#cb007b" />
                      <path d="M24.91,12.1c-2.34,0-4.46.94-6,2.47,1.54,1.56,3.68,2.52,6.05,2.52s4.46-.94,6-2.47c-1.54-1.56-3.68-2.52-6.05-2.52" fill="#cb007b" />
                      <path d="M16.44,8.57h0c0,2.34.94,4.46,2.47,6,1.56-1.54,2.52-3.68,2.52-6.05s-.94-4.46-2.47-6c-1.56,1.54-2.52,3.68-2.52,6.05" fill="#cb007b" />
                      <path d="M12.91,17.04c2.34,0,4.46-.94,6-2.47-1.54-1.56-3.68-2.52-6.05-2.52s-4.46.94-6,2.47c1.54,1.56,3.68,2.52,6.05,2.52" fill="#2b3484" />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    ) : null,
    loaderElement,
  );
}
